<template>
  <div class="form-container container">
    <el-form ref="form" :model="formdata" :rules="rules" label-width="300px">
      <el-divider content-position="left">学生基本信息</el-divider>

      <el-card class="box-card">
        <el-form-item label="入读时间" prop="inTime">
          <el-select v-model="formdata.inTime" placeholder="请选择">
            <el-option
              v-for="item in inTime"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="报读年级" prop="grade">
          <el-select v-model="formdata.grade" placeholder="请选择">
            <el-option
              v-for="item in grade"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="班型意向" prop="classType">
          <el-select v-model="formdata.classType" placeholder="请选择">
            <el-option
              v-for="item in classType"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="姓名" prop="studentName">
          <el-col :span="6">
            <el-input
              v-model="formdata.studentName"
              maxlength="10"
              placeholder="请输入"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="性别" prop="sex">
          <el-select v-model="formdata.sex" placeholder="请选择">
            <el-option
              v-for="item in sex"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="出生日期" prop="birthday">
          <el-date-picker
            type="date"
            placeholder="请选择"
            v-model="formdata.birthday"
            :picker-options="birthdayOptions"
            :default-value="defaultBirthdayDate"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="身份证号码" prop="idCard">
          <el-col :span="12">
            <el-input
              v-model="formdata.idCard"
              maxlength="18"
              placeholder="请输入"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-card>

      <el-divider content-position="left">父亲（第一监护人）信息</el-divider>
      <el-card class="box-card">
        <el-form-item label="姓名" prop="fatherName">
          <el-col :span="6">
            <el-input
              v-model="formdata.fatherName"
              maxlength="10"
              placeholder="请输入"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="学历" prop="fatherEducation">
          <el-select v-model="formdata.fatherEducation" placeholder="请选择">
            <el-option
              v-for="item in education"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工作单位" prop="fatherUnit">
          <el-col :span="16">
            <el-input
              v-model="formdata.fatherUnit"
              maxlength="25"
              placeholder="请输入"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="联系电话" prop="fatherMobile">
          <el-col :span="6">
            <el-input
              v-model="formdata.fatherMobile"
              maxlength="11"
              placeholder="请输入手机号码"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-card>

      <el-divider content-position="left">母亲（第二监护人）信息</el-divider>

      <el-card class="box-card">
        <el-form-item label="姓名" prop="matherName">
          <el-col :span="6">
            <el-input
              v-model="formdata.matherName"
              maxlength="10"
              placeholder="请输入"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="学历" prop="matherEducation">
          <el-select v-model="formdata.matherEducation" placeholder="请选择">
            <el-option
              v-for="item in education"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工作单位" prop="matherUnit">
          <el-col :span="16">
            <el-input
              v-model="formdata.matherUnit"
              maxlength="25"
              placeholder="请输入"
            ></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="联系电话" prop="matherMobile">
          <el-col :span="6">
            <el-input
              v-model="formdata.matherMobile"
              maxlength="11"
              placeholder="请输入手机号码"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-card>

      <el-divider content-position="left">其它信息</el-divider>

      <el-card class="box-card">
        <el-form-item label="是否在本园就读亲子班" prop="isParentingClass">
          <el-select v-model="formdata.isParentingClass" placeholder="请选择">
            <el-option
              v-for="item in isParentingClass"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否有亲兄弟姐妹就读本园或美小" prop="isInSchool">
          <el-select v-model="formdata.isInSchool" placeholder="请选择">
            <el-option
              v-for="item in isInSchool"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="父母是否美的员工" prop="isEmployee">
          <el-select v-model="formdata.isEmployee" placeholder="请选择">
            <el-option
              v-for="item in isEmployee"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否有校车接送需求" prop="isBusing">
          <el-select v-model="formdata.isBusing" placeholder="请选择">
            <el-option
              v-for="item in isBusing"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="家庭住址">
          <el-col :span="6">
            <el-form-item prop="town">
              <el-select
                v-model="formdata.town"
                placeholder="请选择镇街"
                style="width: 100%"
              >
                <el-option
                  v-for="item in town"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="13">
            <el-form-item prop="address">
              <el-input
                v-model="formdata.address"
                maxlength="40"
                placeholder="请输入现住址详细地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="备注">
          <el-col :span="16">
            <el-input v-model="formdata.remark"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-col :span="6">
            <el-input
              type="password"
              v-model="formdata.password"
              placeholder="请输入"
            ></el-input>
          </el-col>
        </el-form-item>
      </el-card>

      <el-form-item style="margin-top: 30px; margin-left: 20px">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { isIdCard, isPhone, isPassword } from "@/utils/validate";
import {
  grade,
  classType,
  sex,
  education,
  isParentingClass,
  isInSchool,
  isEmployee,
  isBusing,
  town,
} from "@/config";
import { setStudents } from "@/utils/students";
import { add } from "@/api/enrolment";
import { getInTime } from "@/api/search";

export default {
  data() {
    var validatePhone = (rule, value, callback) => {
      if (isPhone(value)) {
        callback();
      } else {
        callback(new Error("11位手机号码"));
      }
    };
    var validateIDCard = (rule, value, callback) => {
      if (isIdCard(value)) {
        callback();
      } else {
        callback(new Error("第二代身份证号码或港澳台身份证号码"));
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (isPassword(value)) {
        callback();
      } else {
        callback(new Error("6位以上的数字或字母"));
      }
    };

    const currentDate = new Date();
    var maxDate = new Date(currentDate.getFullYear() - 2, 11, 31);

    return {
      inTime: [],
      grade: grade,
      classType: classType,
      sex: sex,
      education: education,
      isParentingClass: isParentingClass,
      isInSchool: isInSchool,
      isEmployee: isEmployee,
      isBusing: isBusing,
      town: town,
      defaultBirthdayDate: maxDate,
      formdata: {
        // grade: "小小班",
        // classType: "国际班",
        // inTime: "2021年3月入读",
        // studentName: "黎小明",
        // sex: "男",
        // birthday: "2018-12-31",
        // idCard: "440681201812313333",
        // isEmployee: "是",
        // isBusing: "否",
        // fatherName: "1",
        // fatherEducation: "本科",
        // fatherUnit: "1",
        // fatherMobile: "13922222222",
        // matherName: "2",
        // matherEducation: "本科",
        // matherUnit: "2",
        // matherMobile: "13922222222",
        // isParentingClass: "是",
        // isInSchool: "是",
        // town: "勒流镇",
        // address: "1",
        // remark: "",
        // password: "111111",
        grade: "",
        classType: "",
        inTime: "",
        studentName: "",
        sex: "",
        birthday: "",
        idCard: "",
        isEmployee: "",
        isBusing: "",
        fatherName: "",
        fatherEducation: "",
        fatherUnit: "",
        fatherMobile: "",
        matherName: "",
        matherEducation: "",
        matherUnit: "",
        matherMobile: "",
        isParentingClass: "",
        isInSchool: "",
        town: "",
        address: "",
        remark: "",
        password: "",
      },
      rules: {
        inTime: [{ required: true, message: "请选择", trigger: "blur" }],
        grade: [{ required: true, message: "请选择", trigger: "blur" }],
        classType: [{ required: true, message: "请选择", trigger: "blur" }],
        studentName: [{ required: true, message: "请输入", trigger: "blur" }],
        sex: [{ required: true, message: "请选择", trigger: "blur" }],
        birthday: [{ required: true, message: "请选择", trigger: "blur" }],
        idCard: [{ validator: validateIDCard, trigger: "blur" }],
        fatherName: [{ required: true, message: "请输入", trigger: "blur" }],
        fatherEducation: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        fatherUnit: [{ required: true, message: "请输入", trigger: "blur" }],
        fatherMobile: [{ validator: validatePhone, trigger: "blur" }],
        matherName: [{ required: true, message: "请输入", trigger: "blur" }],
        matherEducation: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        matherUnit: [{ required: true, message: "请输入", trigger: "blur" }],
        matherMobile: [{ validator: validatePhone, trigger: "blur" }],
        isParentingClass: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        isInSchool: [{ required: true, message: "请选择", trigger: "blur" }],
        isEmployee: [{ required: true, message: "请选择", trigger: "blur" }],
        isBusing: [{ required: true, message: "请选择", trigger: "blur" }],
        town: [{ required: true, message: "请选择", trigger: "blur" }],
        address: [{ required: true, message: "请输入", trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
      },
      birthdayOptions: {
        disabledDate(time) {
          return time.getTime() > maxDate;
        },
      },
    };
  },
  created: function () {
    this.getInTime();
  },
  methods: {
    getInTime: function () {
      let that = this;
      if (that.inTime && that.inTime.length > 0) return;
      getInTime(function (res) {
        that.inTime = res.data;
      });
    },
    onSubmit: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }

        const loading = this.$loading({
          lock: false,
          text: "提交中",
        });

        const that = this;
        add(
          this.formdata,
          function (res) {
            loading.close();
            that.$message({
              message: "新生报名成功",
              type: "success",
            });
            that.resetData();
            setStudents(res.data);
            that.$router.push("/controlcenter");
          },
          function (res) {
            loading.close();
            that.$message.error(res.msg);
          }
        );
      });
    },
    resetData: function () {
      for (var key in this.formdata) {
        this.formdata[key] = "";
      }
    },
  },
  watch: {
    $route: "getInTime",
  },
};
</script>